export const messageForAddedItem = {
  label: 'compare.message.added.item',
  fallback:
    'The selected product has been successfully added to the comparison list.',
};

export const messageForLastItem = {
  label: 'compare.message.last.item',
  fallback:
    'You can only compare 4 products at a time. Please remove a product from the comparison list to add another',
};

export const messageForMobileCopmaringOneItem = {
  label: 'compare.message.one.item',
  fallback: 'You have to add another product to begin comparing',
};

export const barItemsMessage = {
  label: 'compare.bar.items-message',
  fallback: 'Number of compared products:',
};

export const barClear = {
  label: 'compare.bar.items-clear',
  fallback: 'Clear list',
};

export const addProduct = {
  label: 'compare.bar.add-product',
  fallback: 'Add another product to begin comparing',
};

export const compareCtaText = {
  label: 'compare.bar.compare-button',
  fallback: 'Compare now',
};
